import React, { useState } from "react";

const MessageA23 = (props) => {
  const listData = JSON.parse(props.item.text);

  return (
    <div>
      {listData.data &&
        listData.data.map((data) => (
          <>
            <button
              className="chat-label action-tab"
              id="main-tab1"
              style={{ color: data.disabled && "grey" }}
              onClick={(e) => {
                props.handleClick(props.item.code, data.value);
                props.setTextOnClick(data.name);
                window.open(data.url);
              }}
            >
              {data.name}
            </button>
          </>
        ))}{" "}
    </div>
  );
};

export default MessageA23;
